import { CommonModule } from '@angular/common';
import { Component, computed, model } from '@angular/core';
import { IconButton } from '@malirang/front-share';
import { CalendarLabel } from 'libs/front-share/src/components/calendar-label/calendar-label.component';
import { RangeDay } from './range-day/range-day.component';
import dayjs, { Dayjs } from 'dayjs';

@Component({
  selector: 'app-range-calendar',
  templateUrl: './range-calendar.component.html',
  styleUrls: ['./range-calendar.component.scss'],
  imports: [CommonModule, IconButton, CalendarLabel, RangeDay],
})
export class RangeCalendarComponent {
  date = model<Date>(new Date());

  start = model<Date | null>(null);
  end = model<Date | null>(null);

  days = computed(() => {
    const days: dayjs.Dayjs[] = [];
    const current = dayjs(this.date());

    const firstDayOfMonth = current.startOf('month');
    const lastDayOfMonth = current.endOf('month');
    const daysInMonth = current.daysInMonth();

    // Add days from the previous month to fill the first week
    for (let i = firstDayOfMonth.day() - 1; i >= 0; i--) {
      days.push(firstDayOfMonth.subtract(i + 1, 'day'));
    }

    // Add days of the current month
    for (let i = 0; i < daysInMonth; i++) {
      days.push(firstDayOfMonth.add(i, 'day'));
    }

    // Add days from the next month to fill the last week
    for (let i = 1; i <= 6 - lastDayOfMonth.day(); i++) {
      days.push(lastDayOfMonth.add(i, 'day'));
    }

    return days;
  });

  handleEvent(ev: Date) {
    this.date.set(ev);
  }

  /**
   * @description 년도와 달을 이동하는 통합 함수
   * @param type
   * @param unit
   * @param number
   */
  handleNavigate(
    type: 'prev' | 'next',
    unit: 'year' | 'month',
    number: number,
  ) {
    if (type === 'prev') {
      const value = dayjs(this.date()).subtract(number, unit).toDate();
      this.date.set(value);
    } else {
      const value = dayjs(this.date()).add(number, unit).toDate();
      this.date.set(value);
    }
  }

  handleClick(day: Dayjs) {
    if (!this.start() && !this.end()) {
      this.start.set(day.toDate());
    } else if (this.start() && !this.end()) {
      if (day.isBefore(this.start())) {
        this.end.set(this.start());
        this.start.set(day.toDate());
      } else {
        this.end.set(day.toDate());
      }
    } else {
      this.start.set(day.toDate());
      this.end.set(null);
    }
  }
}
